import * as amplitude from '@amplitude/analytics-browser';


export function handleInstanceAmplitude(user_id: number) {
	const id_usuario = user_id.toString()
	amplitude.init(`${process.env.REACT_APP_AMPLITUDE_API_KEY}`, id_usuario, { minIdLength: 1 })
};

export function handleInstanceAmplitudeCheckout() {
	amplitude.init(`${process.env.REACT_APP_AMPLITUDE_API_KEY}`, "checkout", { minIdLength: 1 })
};

export function AmplitudeLog(log: any, metadata?: any) {
	console.info(log, metadata);
	const eventProperties: any = {
		...metadata,
	};
	return amplitude.track(log, eventProperties)
}


